<h1>Companies</h1>
    <nav mat-tab-nav-bar [tabPanel]="tabs">
        <a mat-tab-link *ngFor="let link of links" (click)="gotoTab(link)"
           [active]="activeLink == link">{{link.title}}</a>
    </nav>
    <app-products-companies *ngIf="activeLink?.title === 'Companies'"></app-products-companies>
    <app-products-permissions *ngIf="activeLink?.title === 'Permissions'"></app-products-permissions>
    <app-products-purchases *ngIf="activeLink?.title === 'Subscriptions'"></app-products-purchases>
    <mat-tab-nav-panel #tabs></mat-tab-nav-panel>
